export const QUERY_KEYS = {
  fillDataForSimulation: 'fillDataForSimulation',
  runPetisSimulation: 'runPetisSimulation',
  validatePolicyholderFiscalNumber: 'validatePolicyholderFiscalNumber',
  policyholderDetails: 'policyholderDetails',
  validateZipCode: 'validateZipCode',
  getEntityDetailsForSummaryDocument: 'getEntityDetailsForSummaryDocument',
  submitPetsInfo: 'submitPetsInfo',
  simulationSummaryDownload: 'simulationSummaryDownload',
  sendSimulationSummaryByEmail: 'sendSimulationSummaryByEmail',
  acceptConditions: 'acceptConditions',
  submitProposal: 'submitProposal',
  sendDigitalSignature: 'sendDigitalSignature',
  loadPolicyHolderReferenceData: 'loadPolicyHolderReferenceData',
  getDigitalSignatureSettings: 'getDigitalSignatureSettings',
} as const
